import { MemberModel } from './../../../../model/member.model';
import { createAction } from '@ngrx/store';
import { props } from '@ngrx/store';

export const RequestAction = createAction('[Member view] get data');
export const ResponseAction = createAction('[Member view] set data',  props<{ payload: MemberModel }>());



